import { BaseAPI } from './base';
import type { PermissionItem } from '../../types/entity/permission';

export class PermissionAPI extends BaseAPI<PermissionItem> {
  constructor() {
    super('/permissions');
  }
}

export const permissionApi = new PermissionAPI();
